const mergeClasses = (...classNames: Array<string | undefined>): string | undefined => {
  const classes = classNames.filter((className) => className !== undefined);

  if (classes.length > 0) {
    return classes.join(' ');
  }

  return undefined;
};

export default mergeClasses;
